import React from "react";
import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { useStoreActions, useStoreState } from "easy-peasy";
import useWindowSize from "../../utils/use_window_size";
import { Panels } from "../../utils/constants";

export default function SettingsMenu({
  open,
  anchorRef,
  setOpenMenu,
  showAdminPopup,
}) {
  const history = useHistory();
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenMenu(false);
  };
  const currentView = useStoreState((state) => state.currentView);
  const setCurrentView = useStoreActions((actions) => actions.setCurrentView);
  const setRequestedView = useStoreActions(
    (actions) => actions.setRequestedView
  );
  // const setSelectedTab = useStoreActions((actions) => actions.setSelectedTab);
  // const setSelectedItemCategory = useStoreActions(
  //   (actions) => actions.setSelectedItemCategory
  // );

  const logout = () => {
    localStorage.removeItem("app_restaurant");
    localStorage.removeItem("app_access_token");
    localStorage.removeItem("app_refresh_token");
    localStorage.removeItem("app_current_view");
    history.replace("/");
  };

  const { isTab } = useWindowSize();
  const isCashierView = currentView === Panels.CASHIER;
  const isAdminView = currentView === Panels.ADMIN;

  const AdminPanelMenuItem = () => {
    return (
      <MenuItem
        onClick={(event) => {
          if (isCashierView) {
            setRequestedView(Panels.ADMIN);
            showAdminPopup();
          } else {
            setCurrentView(Panels.ADMIN);
            history.push("/restaurant/admin");
          }
          handleClose(event);
        }}
      >
        Admin Panel
      </MenuItem>
    );
  };

  const SalesPanelMenuItem = () => {
    return (
      !isTab && (
        <MenuItem
          onClick={(event) => {
            if (isCashierView) {
              setRequestedView(Panels.SALES);
              showAdminPopup();
            } else {
              setCurrentView(Panels.SALES);
              history.replace("/restaurant/sales");
            }
            handleClose(event);
          }}
        >
          Sales Panel
        </MenuItem>
      )
    );
  };

  const SummaryPanelMenuItem = () => {
    return (
      !isTab && (
        <MenuItem
          onClick={(event) => {
            if (isCashierView) {
              setRequestedView(Panels.SUMMARY);
              showAdminPopup();
            } else {
              setCurrentView(Panels.SUMMARY);
              history.replace("/restaurant/summary");
            }
            handleClose(event);
          }}
        >
          Item Summary Panel
        </MenuItem>
      )
    );
  };

  const PayoutsPanelMenuItem = () => {
    return (
      !isTab && (
        <MenuItem
          onClick={(event) => {
            if (isCashierView) {
              setRequestedView(Panels.PAYOUTS);
              showAdminPopup();
            } else {
              setCurrentView(Panels.PAYOUTS);
              history.replace("/restaurant/payouts");
            }
            handleClose(event);
          }}
        >
          Payouts Panel
        </MenuItem>
      )
    );
  };

  const SubscriptionsPanelMenuItem = () => {
    return (
      !isTab && (
        <MenuItem
          onClick={(event) => {
            if (isCashierView) {
              setRequestedView(Panels.SUBSCRIPTIONS);
              showAdminPopup();
            } else {
              setCurrentView(Panels.SUBSCRIPTIONS);
              history.replace("/restaurant/subscriptions");
            }
            handleClose(event);
          }}
        >
          Subscriptions Panel
        </MenuItem>
      )
    );
  };

  const CashierPanelMenuItem = () => {
    return (
      <MenuItem
        onClick={(event) => {
          setCurrentView(Panels.CASHIER);
          if (isAdminView) {
            history.replace("/restaurant/home");
          } else {
            history.push("/restaurant/home");
          }
          handleClose(event);
        }}
      >
        Cashier Panel
      </MenuItem>
    );
  };

  const KitchenPanelMenuItem = () => {
    return (
      !isTab && (
        <MenuItem
          onClick={(event) => {
            setCurrentView(Panels.KITCHEN);
            history.replace("/restaurant/kitchen");
            handleClose(event);
          }}
        >
          Kitchen Panel
        </MenuItem>
      )
    );
  };

  return (
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
      style={{
        zIndex: 5,
      }}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom" ? "center top" : "center bottom",
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList autoFocusItem={open} id="menu-list-grow">
                {currentView === Panels.CASHIER ? (
                  <>
                    <AdminPanelMenuItem />
                    <SalesPanelMenuItem />
                    <SummaryPanelMenuItem />
                    <PayoutsPanelMenuItem />
                    <SubscriptionsPanelMenuItem />
                    <KitchenPanelMenuItem />
                  </>
                ) : currentView === Panels.ADMIN ? (
                  <>
                    <CashierPanelMenuItem />
                    <SalesPanelMenuItem />
                    <SummaryPanelMenuItem />
                    <PayoutsPanelMenuItem />
                    <SubscriptionsPanelMenuItem />
                    <KitchenPanelMenuItem />
                  </>
                ) : currentView === Panels.SALES ? (
                  <>
                    <CashierPanelMenuItem />
                    <SummaryPanelMenuItem />
                    <PayoutsPanelMenuItem />
                    <SubscriptionsPanelMenuItem />
                    <AdminPanelMenuItem />
                    <KitchenPanelMenuItem />
                  </>
                ) : currentView === Panels.PAYOUTS ? (
                  <>
                    <CashierPanelMenuItem />
                    <SalesPanelMenuItem />
                    <SummaryPanelMenuItem />
                    <SubscriptionsPanelMenuItem />
                    <AdminPanelMenuItem />
                    <KitchenPanelMenuItem />
                  </>
                ) : currentView === Panels.SUBSCRIPTIONS ? (
                  <>
                    <CashierPanelMenuItem />
                    <SalesPanelMenuItem />
                    <SummaryPanelMenuItem />
                    <PayoutsPanelMenuItem />
                    <AdminPanelMenuItem />
                    <KitchenPanelMenuItem />
                  </>
                ) : currentView === Panels.SUMMARY ? (
                  <>
                    <CashierPanelMenuItem />
                    <SalesPanelMenuItem />
                    <PayoutsPanelMenuItem />
                    <SubscriptionsPanelMenuItem />
                    <AdminPanelMenuItem />
                    <KitchenPanelMenuItem />
                  </>
                ) : currentView === Panels.KITCHEN ? (
                  <>
                    <CashierPanelMenuItem />
                    <SalesPanelMenuItem />
                    <SummaryPanelMenuItem />
                    <PayoutsPanelMenuItem />
                    <SubscriptionsPanelMenuItem />
                    <AdminPanelMenuItem />
                  </>
                ) : (
                  <div />
                )}

                <MenuItem
                  onClick={(event) => {
                    logout();
                    handleClose(event);
                  }}
                >
                  Logout
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}
